import { GET_CLOTHES_NOT_WASHED_FAILURE, GET_CLOTHES_NOT_WASHED_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_CLOTHES_NOT_WASHED_SUCCESS:
			return onSuccess(state, action);
		case GET_CLOTHES_NOT_WASHED_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
